@if (product) {
<div class="flex flex-column-s flex-column-m flex-bottom flex-top-s flex-top-m">
    @if (product?.data?.has_map || !!product?.data?.map_price) {
    <div class="flex">
        <price class="s1 s2-s s2-m col-1 inline-block va-m line-through"
               [value]="product.orgPrice || product.price"></price>
        <span class="s1 s2-s s2-m col-11 inline-block va-m m-l-2">
            {{ 'See price in cart' | translate }}
        </span>
    </div>
    }
    @else {
    <div class="flex">
        <price class="s1 s2-s s2-m col-1 inline-block va-m"
               [value]="product.price"></price>
        @if (product?.data?.max_price && product.price !== product?.data?.max_price) {
        <span class="s1 s2-s s2-m col-1 inline-block va-m">-</span>
        <price class="s1 s2-s s2-m col-1 inline-block va-m"
               [value]="product?.data?.max_price"></price>
        }
    </div>
    @if (product.orgPrice) {
    <div class="m-l-2-x m-l-2-l m-t-1-s m-t-1-m flex _line-through">
        <price class="p1 p2-s p2-m col-11 inline-block va-m m-r-1"
               [value]="product.orgPrice"></price>
        @if (product?.data?.max_org_price && product.orgPrice !== product?.data?.max_org_price) {
        <span class="p1 p2-s p2-m col-11">-</span>
        <price class="p1 p2-s p2-m col-11 inline-block va-m m-l-1"
               [value]="product?.data?.max_org_price"></price>
        }
    </div>
    }
    }
</div>
}